


























import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { CompendiumStore } from '@/store'
import ReserveCard from '@/ui/components/cards/_ReserveCard.vue'
import _ from 'lodash'

export default Vue.extend({
  name: 'reserves',
  components: { ReserveCard },
  data: () => ({
    tabModel: 0,
  }),
  computed: {
    reserves() {
      const compendium = getModule(CompendiumStore, this.$store)
      return _.groupBy(
        compendium.Reserves.filter(x => x),
        'Type'
      )
    },
  },
})
